const plugin = require('tailwindcss/plugin');
const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
    content: [
        './src/app/**/*.{js,ts,jsx,tsx}',
        './src/pages/**/*.{js,ts,jsx,tsx}',
        './src/components/**/*.{js,ts,jsx,tsx}',
        './src/lib/analytics/colors.js',
        './src/lib/albums/getCardGridStyles.ts',
        './src/lib/pricing/recapPlanCard.ts',
        './src/lib/albums/getCardGridStyles.ts',
        './src/lib/pricing/pricingPlanCard.ts',
        './src/lib/scheduler/postType.ts'
    ],
    darkMode: 'class', // or 'media' or 'class',
    theme: {
        extend: {
            animation: {
                'caret-blink': 'caret-blink 1.2s ease-out infinite',
                'sparks-typing-dot': 'sparks-typing-dot 1.05s ease-in-out infinite',
                progress: 'progress 1s linear infinite',
                'signup-step-circle': 'signup-step-circle 0.5s ease 1 forwards',
                'signup-step-line': 'progress 0.5s linear 1 forwards',
                'ping-small': 'ping-small 2s cubic-bezier(0, 0, 0.2, 1) infinite;'
            },
            aspectRatio: {
                '4/3': '4 / 3',
                '9/16': '9 / 16',
                '2/3': '2 / 3'
            },
            backgroundImage: {
                newPricingGradient:
                    'radial-gradient(circle at 0% 100%, rgba(255, 124, 79, 0.41), rgba(238, 123, 255, 0.76) 30%, #8aa8ff 60%, #0089ff)',
                icoBaseLayer:
                    'radial-gradient(circle at 0 61%,#a6d1ba,#48a6a2 11%,#3d93f1 22%,#a786fd 33%,#d7a2ef 43%, #eed7eb 56%,rgba(255, 255, 255, 0) 58%), linear-gradient(177deg, #c7eed4 -1%, #7aee88 40%, #9ad7d8 72%, #f6f3e3 111%)',
                icoLeftLayer:
                    'radial-gradient(circle at 21% 56%, #a6e0cd, #b1f0bd 37%, rgba(177, 240, 189, 0.19) 85%, rgba(177, 240, 189, 0) 85%)',
                icoRightLayer:
                    'radial-gradient(circle at -4% 20%, rgba(255, 255, 255, 0), #ecf2dc 32%, #f5f4e2 61%)',
                icoLoggedInLayer:
                    'linear-gradient(107deg, rgba(0, 137, 255, 0.10) 0%, rgba(145, 209, 255, 0.15) 25%, rgba(70, 41, 250, 0.15) 50%, rgba(109, 191, 102, 0.20) 75%, rgba(0, 137, 255, 0.30) 100%)',
                icoLoggedInLayerDark:
                    'linear-gradient(107deg, rgba(66.81, 142.09, 255, 0.05) 0%, rgba(56.94, 42.98, 217.55, 0.30) 60%, rgba(135.84, 64.14, 207.54, 0.30) 80%, rgba(21.63, 59.67, 157.46, 0.40) 100%)',
                icoWhiteGradientBottomToTop:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);',
                icoDeepBlackGradientBottomToTop:
                    'linear-gradient(180deg, rgba(9, 10, 13, 0.00) 0%, #090A0D 100%);',
                icoWhiteGradientTopToBottom:
                    'linear-gradient(180deg, #F6F8FB 0%, rgba(246, 248, 251, 0.00) 50%)',
                icoDeepBlackGradientTopToBottom:
                    'linear-gradient(180deg, #14151D 0%, rgba(20, 21, 29, 0.00) 50%)',
                icoGray100GradientBottomToTop:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #F6F8FB 100%);',
                icoRadioLight: `url('${process.env.NEXT_PUBLIC_CDN_URL}/images/svg/customInput/radio-light.svg')`,
                icoRadioDark: `url('${process.env.NEXT_PUBLIC_CDN_URL}/images/svg/customInput/radio-dark.svg')`,
                icoCheckboxLight: `url('${process.env.NEXT_PUBLIC_CDN_URL}/images/svg/customInput/checkbox-light.svg')`,
                icoCheckboxDark: `url('${process.env.NEXT_PUBLIC_CDN_URL}/images/svg/customInput/checkbox-dark.svg')`,
                icoProgressHome:
                    'radial-gradient(circle at 0% 50%, #6fd2fd, #77aff7 26%, #1374f2 64%, #484fe6 100%)',
                icoHomeBlueRadialBorder:
                    'radial-gradient(circle at -9% 118%, #6fd2fd, #6fd2fd 1%, #77aff7 30%, #1374f2 74%, #484fe6 115%)',
                icoHomeGreenLinearBorder: 'linear-gradient(75deg, #4fd046 0%, #98ff91 100%);',
                icoAlbumNoDataLinearGradientLight:
                    'linear-gradient(rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 20%, rgba(255,255,255,1))',
                icoAlbumNoDataLinearGradientDark:
                    'linear-gradient(rgba(15, 18, 30, 0) 0%,rgba(15, 18, 30, 0.8) 20%, rgba(15, 18, 30, 1))',
                icoSignUpLayer:
                    'linear-gradient(112deg, rgba(255, 255, 255, 0.40) 0%, rgba(250, 246, 255, 0.00) 40%, rgba(147, 210, 255, 0.20) 60%, rgba(216, 178, 255, 0.40) 80.42%, rgba(178, 252, 198, 0.10) 100%)',
                icoSignUpGradient1:
                    'linear-gradient(151deg, #F6F8FC 0%, rgba(236, 255, 194, 0.15) 23%, rgba(142, 207, 255, 0.71) 100%)',
                icoSignUpGradient2: 'linear-gradient(152deg, #F6F6FB 0.64%, #C8E5FF 107.94%)',
                icoSignUpGradient3:
                    'linear-gradient(151deg, #F6F6FB 1.94%, rgba(221, 222, 247, 0.46) 32.68%, #B6F9D9 100%)',
                icoSignUpGradient4:
                    'linear-gradient(151deg, rgba(255, 225, 197, 0.92) -9.65%, rgba(239, 221, 247, 0.44) 33.19%, #B6EDF9 100%)',
                icoEmptyStateIllustration:
                    'linear-gradient(108.96deg, #E6F3FF 1.06%, #E3E0FE 46.02%, rgba(253, 235, 170, 0.96) 101.32%)',
                icoPricingPlansLightGradient:
                    'linear-gradient(107deg, rgba(0, 137, 255, 0.10) 0%, rgba(145, 209, 255, 0.15) 25%, rgba(70, 41, 250, 0.15) 50%, rgba(109, 191, 102, 0.20) 75%, rgba(0, 137, 255, 0.30) 100%)',
                icoPricingPlansDarkGradient:
                    'linear-gradient(107deg, rgba(67, 142, 255, 0.05) 0.01%, rgba(57, 43, 218, 0.30) 60%, rgba(136, 64, 208, 0.30) 80%, rgba(22, 60, 157, 0.40) 100%)',
                icoRecapPlanSubscription:
                    'linear-gradient(118deg, rgba(245.88, 248.07, 251.36, 0) 0%, rgba(149, 0, 255, 0.05) 70%, rgba(0, 137, 255, 0.3) 100%)'
            },
            borderRadius: {
                px: '1px',
                m: '3px'
            },
            borderWidth: {
                3: '3px'
            },
            boxShadow: {
                icoSchedulerPost: '-1px 0 3px 0 rgba(29, 29, 27, 0.38)',
                icoSchedulerStackedPost: '0 10px 20px 0 rgba(0, 14, 25, 0.2)',
                icoXS: '0 8px 10px 0 rgba(0, 14, 25, 0.04)',
                icoS: '0 10px 15px 0 rgba(0, 14, 25, 0.15)',
                icoM: '0 16px 20px 0 rgba(0, 14, 25, 0.04)',
                icoL: '0 20px 30px 0 rgba(0, 14, 25, 0.1)',
                icoXL: '0 30px 40px 0 rgba(0, 14, 25, 0.14)',
                icoXXL: '0 30px 50px 0 rgba(0, 14, 25, 0.08)',
                icoDarkXL: '0 30px 40px 0 rgba(0, 0, 0, 0.5)'
            },
            colors: {
                icoBlue: {
                    900: '#151928',
                    DEFAULT: '#0089ff',
                    400: '#1a95ff',
                    300: '#33a1ff',
                    200: '#96D8FF',
                    100: '#e6f3ff'
                },
                icoGreen: {
                    DEFAULT: '#4fd046',
                    400: '#61d559',
                    300: '#72d96b',
                    200: '#BCF2B9',
                    100: '#edfaed'
                },
                icoRed: {
                    DEFAULT: '#ee3034',
                    400: '#f04548',
                    300: '#f1595d',
                    200: '#FBB7B9',
                    100: '#fdeaeb'
                },
                icoYellow: {
                    DEFAULT: '#ffb000',
                    400: '#ffb81a',
                    300: '#ffc033',
                    200: '#FFDC8D',
                    100: '#fff7e6'
                },
                icoPurple: {
                    DEFAULT: '#7900ff',
                    400: '#861aff',
                    300: '#9433ff',
                    200: '#CB9CFF',
                    100: '#f2e6ff'
                },
                icoPink: {
                    DEFAULT: '#e04faa',
                    400: '#e361b3',
                    300: '#e672bb',
                    200: '#FAC3E5',
                    100: '#fcedf7'
                },
                icoAquaBlue: {
                    DEFAULT: '#05ab9b',
                    400: '#1eb3a5',
                    300: '#37bcaf',
                    200: '#98E4DD',
                    100: '#e6f7f5'
                },
                icoOrange: {
                    DEFAULT: '#ff8800',
                    400: '#ffa033',
                    300: '#ffb866',
                    200: '#FFE0BF',
                    100: '#fff3e6'
                },
                icoBlack: {
                    DEFAULT: '#1d1d1b',
                    400: '#091d1b'
                },
                icoGray: {
                    500: '#76869A',
                    400: '#AEB9C6',
                    300: '#E6ECF4',
                    200: '#EBF2F4',
                    100: '#F6F8FB'
                },
                icoGrayFirefox: {
                    300: 'rgba(240, 242, 246, .9)'
                },
                icoWhiteFirefox: {
                    DEFAULT: 'rgba(255, 255, 255, .9)'
                },
                facebook: '#1877f2',
                twitter: '#000000',
                linkedin: '#0a66c2',
                youtube: '#ff0000',
                tiktok: '#000000',
                threads: '#000000',
                icoDarkMode: {
                    deepBlack: '#090A0D',
                    anthracite: '#14151D',
                    goudron: '#141825',
                    beton: '#313548',
                    wolf: '#6C7294',
                    darkBlue: '#3591f9',
                    blueStats: '#54a4ff',
                    green: '#6cd980',
                    aquaBlue: '#50e1c1',
                    purple: '#9769ff',
                    red: '#f15256',
                    yellow: '#ffc44f',
                    pink: '#ff84d1'
                }
            },
            fontFamily: {
                GBold: 'Gilroy-Bold, Arial',
                GSemiBold: 'Gilroy-Semibold, Arial',
                GMedium: 'Gilroy-Medium, Arial',
                PNineties: "'PerfectlyNineties', serif"
            },
            fontSize: {
                7: [
                    '7px',
                    {
                        lineHeight: '.75rem',
                        letterSpacing: '-0.3px'
                    }
                ],
                8: [
                    '8px',
                    {
                        lineHeight: '.75rem',
                        letterSpacing: '-0.3px'
                    }
                ],
                9: [
                    '9px',
                    {
                        lineHeight: '10px',
                        letterSpacing: '0px'
                    }
                ],
                xxs: [
                    '10px',
                    {
                        lineHeight: '.75rem',
                        letterSpacing: '-0.3px'
                    }
                ],
                xs: [
                    '12px',
                    {
                        lineHeight: '0.875rem',
                        letterSpacing: '-0.3px'
                    }
                ],
                13: [
                    '13px',
                    {
                        lineHeight: '0.875rem',
                        letterSpacing: '-0.3px'
                    }
                ],
                sm: [
                    '14px',
                    {
                        lineHeight: '1rem',
                        letterSpacing: '-0.4px'
                    }
                ],
                base: [
                    '16px',
                    {
                        lineHeight: '1.25rem',
                        letterSpacing: '-0.5px'
                    }
                ],
                xl: [
                    '20px',
                    {
                        lineHeight: '25px',
                        letterSpacing: '-0.5px'
                    }
                ],
                xxl: [
                    '24px',
                    {
                        lineHeight: '25px',
                        letterSpacing: '-0.45px'
                    }
                ],
                '3.5xl': [
                    '32px',
                    {
                        lineHeight: '2rem',
                        letterSpacing: '-1px'
                    }
                ],
                '4.5xl': [
                    '42px',
                    {
                        lineHeight: '2rem',
                        letterSpacing: '-1px'
                    }
                ],
                '5xl': [
                    '48px',
                    {
                        lineHeight: '3rem',
                        letterSpacing: '-2px'
                    }
                ]
            },
            keyframes: {
                'caret-blink': {
                    '0%,70%,100%': { opacity: '1' },
                    '20%,50%': { opacity: '0' }
                },
                'sparks-typing-dot': {
                    '0%, 60%, 100%': { transform: 'translateY(0)', opacity: '0.35' },
                    '30%': { transform: 'translateY(-3px)', opacity: '1' }
                },
                progress: {
                    '0%': { width: '0' },
                    '100%': { width: '100%' }
                },
                'ping-small': {
                    '75%, 100%': {
                        transform: 'scale(1.6)',
                        opacity: 0
                    }
                },
                'signup-step-circle': {
                    '0%': {
                        boxShadow:
                            '15px -15px 0 2px #FFFFFF, -15px -15px 0 2px #FFFFFF, -15px 15px 0 2px #FFFFFF, 15px 15px 0 2px #FFFFFF, 0 0 0 2px #FFFFFF',
                        backgroundColor: '#FFFFFF'
                    },
                    '15%': {
                        boxShadow:
                            '0 -35px 0 2px #FFFFFF, -15px -15px 0 2px #FFFFFF, -15px 15px 0 2px #FFFFFF, 15px 15px 0 2px #FFFFFF, 0 0 0 2px #0089ff'
                    },
                    '30%': {
                        boxShadow:
                            '0 -35px 0 2px #FFFFFF, -35px 0px 0 2px #FFFFFF, -15px 15px 0 2px #FFFFFF, 15px 15px 0 2px #FFFFFF, 0 0 0 2px #0089ff'
                    },
                    '45%': {
                        boxShadow:
                            '0 -35px 0 2px #FFFFFF, -35px 0px 0 2px #FFFFFF, 0px 35px 0 2px #FFFFFF, 15px 15px 0 2px #FFFFFF, 0 0 0 2px #0089ff'
                    },
                    '60%': {
                        boxShadow:
                            '0 -35px 0 2px #FFFFFF, -35px 0px 0 2px #FFFFFF, 0px 35px 0 2px #FFFFFF, 34px 10px 0 2px #FFFFFF, 0 0 0 2px #0089ff',
                        backgroundColor: '#FFFFFF'
                    },
                    '100%': {
                        boxShadow:
                            '0 -35px 0 2px #FFFFFF, -35px 0px 0 2px #FFFFFF, 0px 35px 0 2px #FFFFFF, 34px 10px 0 2px #FFFFFF, 0 0 0 2px #0089ff',
                        backgroundColor: '#0089ff'
                    }
                }
            },
            letterSpacing: {
                0.5: '0.5px',
                1: '1px'
            },
            minWidth: {
                150: '150px',
                '1/2': '50%',
                '1/4': '25%',
                56: '14rem'
            },
            maxWidth: {
                15: '15rem',
                container: '1600px',
                content: '1100px',
                '3/4': '75%',
                '1/2': '50%',
                '1/3': '33%'
            },
            minHeight: {
                10: '2.5rem',
                12: '3rem',
                14: '3.5rem'
            },
            maxHeight: {
                500: '500px'
            },
            height: {
                'content-full': 'calc(100vh - 205px)',
                min: 'min-content',
                1.75: '5px'
            },
            spacing: {
                0.75: '3px',
                1.25: '5px',
                1.5: '.375rem',
                xxs: '.625rem',
                m: '1.125rem',
                5.5: '1.375rem',
                7.5: '1.875rem',
                10.5: '2.625rem',
                11.5: '2.875rem',
                12.5: '3.125rem',
                13: '3.25rem',
                15: '3.75rem',
                17: '4.375rem',
                87.5: '350px',
                125: '500px',
                150: '600px',
                175: '700px'
            },
            zIndex: {
                '-1': '-1',
                1: '1',
                2: '2',
                3: '3',
                15: '15',
                100: '100',
                101: '101'
            },
            inset: {
                unset: 'unset',
                0.5: '2px'
            },
            backdropBlur: {
                6: '6px',
                20: '20px'
            },
            screens: {
                '3xl': '2000px'
            },
            transitionProperty: {
                height: 'height'
            },
            gridTemplateRows: {
                '5-auto': 'repeat(5, minmax(0, auto))',
                8: 'repeat(8, minmax(0, 1fr))',
                12: 'repeat(12, minmax(0, 1fr))'
            },
            gridRowStart: {
                8: '8',
                9: '9',
                10: '10',
                11: '11',
                12: '12'
            },
            gridRow: {
                'span-7': 'span 7 / span 7',
                'span-8': 'span 8 / span 8',
                'span-9': 'span 9 / span 9'
            },
            transitionDelay: {
                1500: '1500ms',
                2000: '2000ms',
                2500: '2500ms',
                3000: '3000ms'
            }
        },
        aspectRatio: {
            0.52: '0.52',
            0.75: '0.75',
            0.93: '0.93',
            1: '1',
            1.78: '1.78',
            1.2: '1.2',
            2: '2'
        },
        screens: {
            xs: '426px',
            ...defaultTheme.screens
        },
        fontFamily: {
            ico2021: ['ico2021']
        }
    },
    variants: {
        extend: {
            textColor: ['active']
        }
    },
    plugins: [
        require('@tailwindcss/forms'),
        require('@tailwindcss/aspect-ratio'),
        plugin(function ({ addVariant, e, postcss }) {
            addVariant('firefox', ({ container, separator }) => {
                const isFirefoxRule = postcss.atRule({
                    name: '-moz-document',
                    params: 'url-prefix()'
                });
                isFirefoxRule.append(container.nodes);
                container.append(isFirefoxRule);
                isFirefoxRule.walkRules((rule) => {
                    rule.selector = `.${e(`firefox${separator}${rule.selector.slice(1)}`)}`;
                });
            });
        }),
        plugin(function ({ addUtilities }) {
            addUtilities({
                '.no-scrollbar::-webkit-scrollbar': {
                    display: 'none'
                },
                '.no-scrollbar': {
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none'
                }
            });
        }),
        plugin(function ({ addUtilities }) {
            addUtilities({
                '.capitalize-first:first-letter': {
                    textTransform: 'uppercase'
                }
            });
        }),
        plugin(function ({ matchUtilities, theme }) {
            matchUtilities(
                {
                    'animate-delay': (value) => ({
                        animationDelay: value
                    })
                },
                { values: theme('transitionDelay') }
            );
        }),
        require('@tailwindcss/container-queries')
    ]
};
